import React, { FunctionComponent } from 'react'
import { Text, Flag, PopoverListItem } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { useReceipts } from './useReceipts'

interface SelectDefaultReceiptParams {
  type: 'default'
}

interface SelectOtherTemplateParams {
  type: 'other'
  receiptTemplateId: string
}

export type SelectReceiptParams =
  | SelectDefaultReceiptParams
  | SelectOtherTemplateParams

interface ReceiptTemplateListProps {
  selectReceipt: (params: SelectReceiptParams) => void
}

export const ReceiptTemplateList: FunctionComponent<ReceiptTemplateListProps> = ({
  selectReceipt,
}) => {
  const { defaultReceipt, otherReceipts } = useReceipts()

  return (
    <>
      <li className="wr-receipt-selection-header" key="heading">
        <Text type="label">
          <T _str="Receipt templates" />
        </Text>
      </li>
      {defaultReceipt && (
        <PopoverListItem
          index={0}
          onClick={() => {
            selectReceipt({ type: 'default' })
          }}
        >
          {defaultReceipt.name}&nbsp;
          <Flag
            content={
              <T
                _str="Default"
                _context="Label marking default receipt template in list"
              />
            }
          />
        </PopoverListItem>
      )}
      {otherReceipts.map((receipt, index) => (
        <PopoverListItem
          key={receipt.id}
          index={index + 1}
          onClick={() =>
            selectReceipt({ type: 'other', receiptTemplateId: receipt.id })
          }
        >
          {receipt.name}
        </PopoverListItem>
      ))}
    </>
  )
}
